import React, {useState} from "react";
import {useAsync} from "react-async-hook";
import {Column} from "react-table";
import {ListTable} from "./ListTable";
import useLoading from "../../../../hooks/useLoading";
import {config} from "../../../../libs/config/config";

export interface SearchParams {
  keyword: string;
  size: number;
  currentPage: number;
  sort: Array<string>;
}

interface ListTableWithSearchProps<D extends object> {
  tableData: D[];
  columns: Column<D>[];
  initialSort: string[] // 「＜カラム名＞:＜ソート順（asc or desc）＞」の形式
  totalCount: number;
  sortFunc: (params: SearchParams) => Promise<void>;
}

export const ListTableWithSearchBox = <DataType extends object>(props: ListTableWithSearchProps<DataType>) => {
  const {
    tableData,
    columns,
    initialSort,
    totalCount,
    sortFunc,
  } = props;
  const [keyword, setKeyword] = useState<string>('');
  const [params, setParams] = React.useState<SearchParams>({
    keyword: '',
    size: config.list.pageSizeOptions[0],
    currentPage: 1,
    sort: initialSort,
  });
  const withLoading = useLoading();

  useAsync(async () => {
    withLoading(() => sortFunc(params));
  }, [params]);

  const handleSearch = async (newKeyword: string) => {
    setParams(prevState => ({
      ...prevState,
      keyword: newKeyword,
      currentPage: 1,
    }));
  };

  const handleSort = async (newSort: string[]) => {
    if ((params.sort.length === newSort.length)
      && params.sort.every((sort, index) => sort === newSort[index])) {
      return
    }

    setParams(prevState => ({
      ...prevState,
      sort: newSort,
      currentPage: 1,
    }));
  };

  const handlePageChange = async (selectedItem: { selected: number }) => {
    setParams(prevState => ({
      ...prevState,
      currentPage: selectedItem.selected + 1,
    }));
  };

  const handlePageSizeChange = async (newSize: number) => {
    setParams(prevState => ({
      ...prevState,
      size: newSize,
      currentPage: 1,
    }));
  };

  return (
    <>
      <div className="flex justify-end items-center mb-3">
        { /* Todo: Enterイベントでの発火を追加 */ }
        <input className="w-2/5 text-field"
               value={keyword}
               onChange={(e) => setKeyword(e.target.value)}
        />
        <div>
          <button className="btn-primary ml-1"
                  type='button'
                  onClick={async () => {
                    await handleSearch(keyword);
                  }}
          >
            検 索
          </button>
        </div>
      </div>

      <ListTable
        {...{
          tableData,
          columns,
          onSort: handleSort,
          initialSort,
          totalCount,
          pageSize: params.size,
          currentPage: params.currentPage,
          onPageChange: handlePageChange,
          onPageSizeChange: handlePageSizeChange,
        }}
      />
    </>
  );
};